module.exports = __webpack_public_path__ + "static/media/phone-dark.a64e8192.svg";